import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

const _getTabItemStyle = ($tabsCount: number) => {
  return css`
    flex-basis: calc(100% / ${$tabsCount});
    @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
      flex-basis: ${$tabsCount === 2 ? '0' : `calc(100% / ${$tabsCount})`};
    }
  `
}

const _getActiveTabLineStyles = (
  $leftPosition: number,
  _$rightPosition: number
) => {
  // Simplified without RTL support for v-editor-spa
  return css`
    left: 0;
    transform: translateX(${$leftPosition}px);
  `
}

export const TabbarWrapper = styled.div`
  border-bottom: 1px solid ${COLORS.borderColor};
  width: 100%;
`

interface ITabbarProps {
  $tabsCount: number
}

export const Tabbar = styled.div<ITabbarProps>`
  position: relative;
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: space-evenly;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }

  .tabbar-item {
    ${({ $tabsCount }) => $tabsCount && _getTabItemStyle($tabsCount)}
  }
`

export const ActiveTabLine = styled.div`
  width: 100%;
  height: 3px;
  background: ${COLORS.primaryDark};
  border-radius: 2px 2px 0px 0px;
`

interface IActiveTabLineWrapperProps {
  $tabWrapperWidth: number
  $rightPosition: number
  $leftPosition: number
}

export const ActiveTabLineWrapper = styled.div<IActiveTabLineWrapperProps>`
  position: absolute;
  width: ${props => props.$tabWrapperWidth + 20}px;
  bottom: 0;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: all 0.2s ease-out;
  ${({ $leftPosition, $rightPosition }) =>
    _getActiveTabLineStyles($leftPosition - 10, $rightPosition)}
`
